<template>
  <div id="app">
    <TitleBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import TitleBar from './components/TitleBar.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    TitleBar,
    Footer
  }
};
</script>

<style>
/* Add global styles here if necessary */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  line-height: 1.6;
  color: #333;
  background: #f4f4f4;
}
</style>